import store from '../store'

const mixin = {
    methods: {
        isEditable(){
            return this.$root.isUserCanEdit( this.report );
        },
        getReport(id){
	        console.log("getReport");

            var self = this
            if(id == self.report.id && !self.$root.is_reload_needed)
                return
            self.$root.is_reload_needed = false
            self.$root.ui.loading.push('pageLoading')
            return self.$store.dispatch('getReport', id).then(function(res){
                self.$root.ui.stopLoading('pageLoading')
                if(self.isAldReport())
                    self.getCarReports()
            })
        },
        getReportByCode(code){
            var self = this
            if( !code )
                return

            self.$root.ui.loading.push('pageLoading')
            return self.$store.dispatch('getReportByCode', code).then(function(res){
                self.$root.ui.stopLoading('pageLoading')
            })
        },
        sendReport(){
            var self = this

            self.$root.ui.loading.push('sendReport')
            return self.$store.dispatch('sendReport').then(function (data) {
                self.$root.ui.stopLoading('sendReport')
                return data
            })
        },
        confirmReport(status){
            var self = this;
            let code = self.$root.$route.params.code;
            self.$root.ui.loading.push('confirmReport')
            return self.$store.dispatch('confirmReport', {status, code}).then((status)=>{
                self.$root.ui.stopLoading('confirmReport')
                return status
            })
        },
        updateAnswers(event, category){
            var self = this
            var answers = category.items.filter( ( answer, idx ) => {
                var res = !answer.state && answer.state != 0;
                if(res) answer.state = 1
                return res;
            })

            if(!answers.length)
                return []
                
            return self.saveAnswers(answers)
        },
        preCheckAnswers(category){
	        console.log(preCheckAnswers);
            var self = this
            var answers = category.items.filter( ( answer, idx ) => {
                var res = !answer.state && answer.state != 0;
                if(res) answer.state = 1
                return res;
            })

            if(!answers.length)
                return []
            return self.saveAnswers(answers)
        },
        next(){
	        
	        console.log("Section id:" + this.$route.params.num);
	        //console.log(this.$route.params.id);
	        // If last section
            if( (this.$route.name == 'report-section' || this.$route.name == 'report-images') && this.sections.length <= this.$route.params.num) {
                this.$router.push({name: 'report', params: {id: this.$route.params.id}})
            }
            // If section before images
            else if(this.$route.params.num == 1){
                this.$router.push({name: 'report-images', params: {id: this.$route.params.id, num: (parseInt(this.$route.params.num)+1)}})
            }
            // else just send to next section
            else if(this.$route.name == 'report-section' || this.$route.name == 'report-images'){
                this.$router.push({name: 'report-section', params: {id: this.$route.params.id, num: (parseInt(this.$route.params.num)+1)}})
            }
        },
        deliver(){
            if(this.$route.name == 'report-images'){
                this.$router.push({name: 'report', params: {id: this.$route.params.id}})
            }
        },
        previous(){
            this.$router.push({ name: 'index'})
        },
        removeAnswerImage(item, index){
            let self = this;
            self.$dialog.confirm('Ønsker du å slette bildet?', {
                cancelText: 'Avbryt',
                okText: 'Ja',
                backdropClose: true
            }).then(()=>{
                item.images.splice(index, 1);
                return self.saveAnswers([item])
            })
        },
        uploadImage1(event, item){
            var input = event.target
            var self = this
            var file = input.files[0];
            self.$store.dispatch('sendApiReportTest',{file:file})
        },
        uploadImage(event, item){
	        
	        console.log("upload image:");
	        console.log(item);
            var input = event.target
            var type = input.dataset.file
            var self = this

            var file = input.files[0];

            if(!file){
                return;
            }

            var reader = new FileReader();
            reader.onload = function(event) {
                if(!item.images)
                    item.images = []

                item.image_file = file

                return self.saveAnswers([item])
            }

            reader.readAsDataURL(file);
            input.value = '';

            return true
        },
        uploadImageDelivery(event, item, category){

            console.log("Update Deliver Image");

            //this.updateAnswers(event, category)
            this.changeAnswerState(item,1)

            var input = event.target
            var type = input.dataset.file
            var self = this

            var file = input.files[0];

            if(!file){
                return;
            }

            var reader = new FileReader();
            reader.onload = function(event) {
                item.image = reader.result
                item.image_file = file
                return self.saveAnswers([item])
            }

            reader.readAsDataURL(file);
            input.value = '';

            return true
        },
        /*
        saveAnswer(item){
            var self = this
            const marker = (new Date()).getTime()
            self.$root.ui.marker = marker
            self.$root.ui.loading = 'dataSaving'
            return this.$store.dispatch('sendAnswer', item).then(function(res){
                if(self.$root.ui.marker == marker)
                    self.$root.ui.loading = false
            })
        },
        */
        changeAnswerState(item, state){
            //item.state = (parseInt(item.state) === state) ? undefined : state
            //return this.saveAnswer(item)
            var self = this
            item.state = (parseInt(item.state) === state) ? undefined : state
            return self.saveAnswers([item])
        },
        addLineItem(item){

	        let items = this.report_items;

			items.forEach(function(thisitem) {


			    if (thisitem.id == item.id){
				    console.log("found");
				    let copy = JSON.parse(JSON.stringify(item.lineitems[0]));

		            copy.created_at = null
		            copy.description = null
                    copy.category = null
		            copy.cost = null
		            copy.id = null

		            thisitem.lineitems.push(copy);
			    }

			});

            //store.commit('set', {type: 'report_items', val: items})
        },
        copyEmptyItem(item){
            let copy = JSON.parse(JSON.stringify(item));
            
            var emptyLineItem = [];
            emptyLineItem.id = "";
            emptyLineItem.description = "";
            emptyLineItem.description_en = "";
            emptyLineItem.description_da = "";
            emptyLineItem.description_sv = "";
            emptyLineItem.category = "";
            emptyLineItem.cost = "";
            
            var emptyLineItems = [emptyLineItem];


            copy.condition_value = null
            copy.extra_value = null
            copy.created_at = null
            copy.description = null
            copy.estimate = null
            copy.id = null
            copy.state = null
            copy.lineitems = emptyLineItems
            copy.updated_at = null
            copy.images = null
            let items = this.report_items
            items.push(copy)

            //store.commit('set', {type: 'report_items', val: items})
        },
        addCustomItem(category){
            let items = this.report_items;
            
            var emptyLineItem = [];
            emptyLineItem.id = "";
            emptyLineItem.description = "";
            emptyLineItem.category = "";
            emptyLineItem.cost = "";
            
            var emptyLineItems = [emptyLineItem];  
            
            items.push({
                caption: "Skade",
                id_report_section: this.section.id,
                section_caption: this.section.caption,
                section_group: this.section.sectionGroup,
                section_view_order: this.section.sectionViewOrder,
                id_report_category: category.id,
                category_caption: category.caption,
                description: null,
                estimate: null,
                lineitems: emptyLineItems,
                condition_value: null,
                extra_value: null,
                id: null,
                id_report: this.report.id,
                id_report_item: null,
                state: null,
                created_at: null,
                updated_at: null
            });
            store.commit('set', {type: 'report_items', val: items})
        },
        addCustomImage(category){
            let items = this.report_items;

            var emptyLineItem = [];
            emptyLineItem.id = "";
            emptyLineItem.description = "";
            emptyLineItem.category = "";
            emptyLineItem.cost = "";

            var emptyLineItems = [emptyLineItem];

            items.push({
                caption: "Ekstra bilde",
                id_report_section: this.section.id,
                section_caption: this.section.caption,
                section_group: this.section.sectionGroup,
                section_view_order: this.section.sectionViewOrder,
                id_report_category: category.id,
                category_caption: category.caption,
                description: null,
                estimate: null,
                lineitems: emptyLineItems,
                condition_value: null,
                extra_value: null,
                id: null,
                id_report: this.report.id,
                id_report_item: null,
                state: null,
                created_at: null,
                updated_at: null
            })

            store.commit('set', {type: 'report_items', val: items})
        },
        saveAnswers(answers){
	        
	        console.log("saveAnswers");
	        
            var self = this
            self.$root.ui.loading.push('sendAnswers')
            return self.$store.dispatch('sendAnswers', answers).then(function (ids) {
                self.$root.ui.stopLoading('sendAnswers')
                
                return ids
            })
        },
        onAutoReplySelect(item,val){
            //console.log(val)
            if(!val.content)
                return true;
            if(item.description == val.content)
                return true;

            item.description = val.content;
            this.saveAnswers([item]);
        },
        onLineItemChange(lineItem){
            lineItem.category = '';
        },
        onLineItemSelect(item, lineItem, val){
            console.log(val);
            if(!val.description)
                return true;
            if(lineItem.description == val.description)
                return true;

            lineItem.description = val.description;
            lineItem.description_en = val.description_en;
            lineItem.description_da = val.description_da;
            lineItem.description_sv = val.description_sv;
            lineItem.category = val.category;

            this.saveAnswers([item]);
        },
        getLatestReport(){
            var self = this;
            var id_car = self.report.id_car.replace(/[^\dA-Za-z]/gi, '');
            if(!id_car.match(/^[A-Za-z]{2}\d{5}$/gi)) return;
            self.$root.ui.loading.push('sendReport')
            return self.$store.dispatch('getLatestReport', id_car).then(function(res){
                self.$root.ui.stopLoading('sendReport')
                if(res.report && res.report.id)
                    self.latest_report_id = res.report.id
                if(res.car)
                    self.$store.commit('set', {type: 'car', val: res.car})
            })
        },
        discountIsActive(){
            return !this.report.car_market && this.report.discount
        },
        addServiceHistoryItem(){
            this.report.service_history.push([null,null])
        },
        setLanguageForNewReport(defaultReport) {
            var self = this, defaultLanguage = self.$root.user.default_user_language;

            if (defaultLanguage && '' !== defaultLanguage) {
                return defaultLanguage;
            }
        }
    },
    beforeRouteUpdate: function(to, from, next){
        next(vm => {})
        if(to.params.id)
            this.getReport(to.params.id)
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            let defaultReport = {};
            if(to.name == 'report-new'){
                if(vm.$root.isRental())
                    defaultReport = {
                        id_report_type: 2
                    }
                if(vm.$root.isRentalCheckUser())
                    defaultReport = {
                        id_report_type: 5
                    }
                if(vm.$root.isEuropcar()) {
                    if (vm.$root.isEuropcarDenmark()) {
                        defaultReport = {
                            id_report_type: 4,
                            firma: 'Europcar',
                            report_role: 'europcar_denmark'
                        }
                    } else {
                        defaultReport = {
                            id_report_type: 4,
                            firma: 'Europcar',
                        }
                    }

                }

                if(vm.$root.isCirclek()) {
                    defaultReport = {
                        id_report_type: 1,
                        report_role: 'circlek_admin'
                    }
                }

                if(vm.$root.isEuropcarUser()) {
                    if(vm.$root.user.department_name)
                        defaultReport.firma = vm.$root.user.department_name;
                }
                if(vm.$root.isAld()) {
                    defaultReport = {
                        id_report_type: 6,
                        firma: 'ALD'
                    }
                }

                if( vm.$root.isUser() && vm.$root.user && vm.$root.user.user_login && vm.$root.user.user_login == "hansabg"){
                    defaultReport.contact_name = "Hans";
                    defaultReport.contact_phone = "40038836";
                    defaultReport.contact_email = "skade.sor@abg.com";
                    defaultReport.firma = "DVT Bilutleie / Agder og Rogaland Bilutleie AS";
                }

                if( vm.$root.isUser() && vm.$root.user && vm.$root.user.user_login && vm.$root.user.user_login == "takst"){
                    defaultReport.contact_name = "Vetle Edvardsen";
                    defaultReport.contact_email = "takst@abg.com";
                    defaultReport.firma = "RAC Norway AS";
                }

                if( vm.$root.isUser() && vm.$root.user && vm.$root.user.user_login && vm.$root.user.user_login == "tromso.damage"){
                    defaultReport.contact_email = "tromso.damage@abg.com";
                    defaultReport.firma = "Avis Tromsø";
                }


                let defaultLanguage = vm.setLanguageForNewReport(defaultReport);
                if ('' !== defaultLanguage && undefined !== defaultLanguage) {
                    defaultReport.report_language = defaultLanguage;
                }

                store.commit('new', {report: defaultReport})
            }
        })
    },
    created(){
        if(this.$route.params.id)
            this.getReport(this.$route.params.id)
        if(this.$route.params.code)
            this.getReportByCode(this.$route.params.code)
    }
}
export default mixin



// WEBPACK FOOTER //
// ./reports/assets/src/mixins/report.js